export default __webpack_public_path__ + "static/media/Aseguradora.e03210fd.svg";